import { IRequest } from '../interfaces/IRequest'
import { api, getAuthHeader } from '../utils/api'
import { IUser, IUserActivity } from '../interfaces/IUsers'
import { API_PATHS } from '../enums/apiPaths'
import { ITurnoverData } from '../interfaces/IDashboard'

export function getUsersOptions(): Promise<{
  body: { data: IUser[] }
}> {
  const params: IRequest = {
    endpoint: `${API_PATHS.users}`,
    method: 'GET',
    headers: getAuthHeader(),
  }

  return api(params)
}

export async function getUserActivity(
  userId?: number | undefined
): Promise<IUserActivity> {
  if (!userId) {
    return {} as IUserActivity
  }

  const params: IRequest = {
    endpoint: `${API_PATHS.users}/${userId}${API_PATHS.activity}`,
  }

  const { body } = await api(params)

  return body
}

export async function getUserTurnoverData(
  userId?: number | undefined
): Promise<ITurnoverData> {
  if (!userId) {
    return {} as ITurnoverData
  }

  const params: IRequest = {
    endpoint: `${API_PATHS.users}/${userId}${API_PATHS.turnover}`,
  }

  const { body } = await api(params)

  return body
}
